import { useStore } from "..";
export const useProfile = () => useStore(({ profile }) => profile);
